import { IonButton, IonIcon } from '@ionic/react'
import IBaseButtonProps from './base-button-props.interface'

const BaseButton: React.FC<IBaseButtonProps> = (props) => {
  const finalProps: IBaseButtonProps = Object.assign({ color: 'primary', iconSlot: 'start', disabled: false, type: 'button' }, props)

  const finalInlineProps: any = {}
  if (!!finalProps.onClickFunction) {
    finalInlineProps.onClick = finalProps.onClickFunction
  }
  if (!!finalProps.id) {
    finalInlineProps.id = finalProps.id
  }
  if (!!finalProps.size) {
    finalInlineProps.size = finalProps.size
  }
  if (!!finalProps.fill) {
    finalInlineProps.fill = finalProps.fill
  }

  return (
    <IonButton
      className={`edisu-base-button ${finalProps.extraClassName ?? ''}`}
      color={finalProps.color}
      disabled={finalProps.disabled}
      type={finalProps.type}
      {...finalInlineProps}
    >
      {!!finalProps.icon && <IonIcon slot={finalProps.iconSlot} icon={finalProps.icon}></IonIcon>}
      {!!finalProps.label && finalProps.label}
    </IonButton>
  )
}

export default BaseButton
